import { IN_SEASON } from '../../constants/mapLayerIds';

/**
 * Extracts the application layers from the seasonObject passed in
 * @param {Object} seasonObject
 * @return {Object}
 */
export function extractApplicationLayers(seasonObject) {

  // Check if there's liquid data to construct the layer
  if (seasonObject.liquidData) {
    // Only return the application layer if this season actually has real application data
    // The hasApplicationData flag is set by the precision planting saga based on real application data validation
    if (seasonObject.hasApplicationData !== false) {
      const { crop, liquidEndDate } = seasonObject.liquidData[0];
      const activeApplication = `${liquidEndDate}_${crop}`;
      return {
        [IN_SEASON.APPLICATIONS]: {
          activeSubLayerIds: [activeApplication, activeApplication],
          subLayers: {},
        },
      };
    }
  }
  return {};
}
